import { toast } from "react-toastify";

import {
  fetchBillingDashboardFailure,
  fetchBillingDashboardStart,
  fetchBillingDashboardSuccess,
  fetchDashboardFailure,
  fetchDashboardStart,
  fetchDashboardSuccess,
} from "./reducer";
import {
  getDashboarBillingDataService,
  getDashboarDataService,
} from "../../Services/DashboardService";

export const fetchDashboardDataList = () => async (dispatch) => {
  try {
    dispatch(fetchDashboardStart());
    const response = await getDashboarDataService();

    if (response?.success) {
      dispatch(
        fetchDashboardSuccess({
          dashboardData: response.data,
        }),
      );
    } else {
      dispatch(fetchDashboardFailure("No data found"));
    }
  } catch (error) {
    toast.error(error || "Something went wrong");

    dispatch(fetchDashboardFailure(error));
  }
};

export const fetchDashboardBillingDataList = (id) => async (dispatch) => {
  try {
    dispatch(fetchBillingDashboardStart());
    const response = await getDashboarBillingDataService(id);

    if (response?.success) {
      dispatch(
        fetchBillingDashboardSuccess({
          dashboardBillingData: response.data,
        }),
      );
    } else {
      dispatch(fetchBillingDashboardFailure("No data found"));
    }
  } catch (error) {
    toast.error(error || "Something went wrong");

    dispatch(fetchBillingDashboardFailure(error));
  }
};
